import { faCalendarDays, faHouse, faTicket, faUser, faUserPlus } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Basket } from "./Basket";

/**
 * The storefront's navigation.
 *
 * A bottom bar because this is a phone product first, and because it gives a
 * supporter somewhere to go after they've bought — without it the shop is a
 * one-way street that ends at a confirmation page.
 *
 * Four tabs, five where a club sells memberships. Fanbase carry Home,
 * Schedule, Wallet, Join and More; More still needs content to put in it, and a
 * tab that opens an empty page is worse than one that isn't there — so Join
 * appears only for clubs that actually offer something to join.
 */
export function ShopNav({ slug, basketVersion, showJoin }: { slug: string; basketVersion?: number; showJoin?: boolean }) {
	const location = useLocation();
	void basketVersion;

	const count = Basket.count(slug);
	const path = location.pathname;

	const tabs = [
		{ icon: faHouse, key: "home", label: "Home", to: `/club/${slug}` },
		{ icon: faCalendarDays, key: "schedule", label: "Schedule", to: `/club/${slug}/schedule` },
		{ badge: count, icon: faTicket, key: "tickets", label: "Tickets", to: `/club/${slug}/tickets` },
		...(showJoin ? [{ icon: faUserPlus, key: "join", label: "Join", to: `/club/${slug}/join` }] : []),
		{ icon: faUser, key: "account", label: "Account", to: `/club/${slug}/account` }
	];

	// Exact match for home, prefix for the rest — otherwise every tab lights up
	// on the home path, which is a prefix of all of them.
	const isActive = (to: string) =>
		to === `/club/${slug}` ? path === to || path === `${to}/` : path.startsWith(to);

	return (
		<nav className="shop-nav">
			{tabs.map((tab) => (
				<Link className={`shop-nav-item${isActive(tab.to) ? " active" : ""}`} key={tab.key} to={tab.to}>
					<span className="shop-nav-icon">
						<FontAwesomeIcon icon={tab.icon} />
						{!!tab.badge && tab.badge > 0 && <span className="shop-nav-badge">{tab.badge}</span>}
					</span>
					<span>{tab.label}</span>
				</Link>
			))}
		</nav>
	);
}
